import React from 'react';

const SortedTooltip = ({ active, payload, label, formatter }) => {
  if (!active || !payload?.length) return null;
  const sorted = [...payload].filter(p => p.value != null).sort((a, b) => (b.value || 0) - (a.value || 0));
  const fmt = formatter || ((v) => v);
  return (
    <div style={{ background: '#1A1A1A', border: '1px solid #333333', borderRadius: '4px', padding: '12px 16px', fontFamily: "'IBM Plex Mono', monospace" }}>
      <div style={{ color: '#737373', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px', paddingBottom: '6px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>{label}</div>
      {sorted.map((entry, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: i < sorted.length - 1 ? '4px' : 0 }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: entry.color, flexShrink: 0 }} />
          <span style={{ color: '#737373', fontSize: '12px', flex: 1 }}>{entry.name}</span>
          <span style={{ color: '#FCFCFC', fontSize: '13px', fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>{fmt(entry.value, entry.name)}</span>
        </div>
      ))}
    </div>
  );
};

export default SortedTooltip;
